import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';

export const YarnWeight = ({ value, onChange, editMode = false }) => {
  const weights = [
    { id: 'lace', label: 'Lace', image: '/symbols/weight-0-lace.jpg' },
    { id: 'superfine', label: 'Super Fine', image: '/symbols/weight-1-superfine.jpg' },
    { id: 'fine', label: 'Fine', image: '/symbols/weight-2-fine.jpg' },
    { id: 'light', label: 'Light', image: '/symbols/weight-3-light.jpg' },
    { id: 'medium', label: 'Medium', image: '/symbols/weight-4-medium.jpg' },
    { id: 'bulky', label: 'Bulky', image: '/symbols/weight-5-bulky.jpg' },
    { id: 'superbulky', label: 'Super Bulky', image: '/symbols/weight-6-superbulky.jpg' },
    { id: 'jumbo', label: 'Jumbo', image: '/symbols/weight-7-jumbo.jpg' },
  ];

  if (editMode) {
    return (
      <FormControl fullWidth margin="normal">
        <InputLabel>Yarn Weight</InputLabel>
        <Select
          value={value || ''}
          onChange={(e) => onChange('yarnWeight', e.target.value)}
          label="Yarn Weight"
          size="small"
        >
          {weights.map((weight) => (
            <MenuItem key={weight.id} value={weight.id}>
              <Box display="flex" alignItems="center">
                <img 
                  src={weight.image} 
                  alt={weight.label} 
                  style={{ 
                    height: 24, 
                    marginRight: 8,
                    objectFit: 'contain'
                  }} 
                />
                {weight.label}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }


  const selectedWeight = weights.find(w => w.id === value);
  if (!selectedWeight) return null;

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Weight of Yarn</Typography>
      <img src={selectedWeight.image} alt={selectedWeight.label} style={{ height: 30, objectFit: 'contain' }} />
    </Box>
  );
};

export default YarnWeight;
